
const ACCOUNT_ALIAS = document.querySelector('meta[name="hr:customer:alias"]').getAttribute('content');
const SELECT_AREA = '#filter_area';
const SELECT_LOCATION = '#filter_location';
const INPUT_TEXT = '#filter_text';
const IS_INTERNAL = document.location.href.toLowerCase().indexOf('internal') > 0 ? true : false;

$(function () {
    load_localities();
    load_areas();
    $(SELECT_AREA).change(search);
    $(SELECT_LOCATION).change(search);
});

function search(e) {
    $('#form_search').submit();
}

async function load_localities() {
    let area = $(SELECT_AREA).val();
    let loc = $(SELECT_LOCATION).val();
    let filterText = $(INPUT_TEXT).val();

    try {
        let data = await http_request('/app/vacancy/get_acc_localities_ajax', {
            account: ACCOUNT_ALIAS,
            areas: area,
            multiple: '',
            internal: IS_INTERNAL,
            filter_text: filterText
        });

        if (!data) {
            return;
        }

        let options = $.map(data, value => {
            let locality = value.name.split(',')[0];

            let selectedFlag = loc === value.id ? 'selected' : '';
            return `<option ${selectedFlag} value="${value.id}">${locality} (${value.cantidad})</option>`;
        });

        $(SELECT_LOCATION).empty();
        $(SELECT_LOCATION).append(`<option value="" ${loc === '' ? 'selected' : ''}>Ubicación</option>`);
        $(SELECT_LOCATION).append(options);

    } catch (err) {
        console.error(err);
    }
}

async function load_areas() {
    let loc = $(SELECT_LOCATION).val();
    let area = $(SELECT_AREA).val();
    let filterText = $(INPUT_TEXT).val();

    try {
        let data = await http_request('/app/vacancy/get_acc_areas_ajax', {
            account: ACCOUNT_ALIAS,
            locality: loc,
            multiple: '',
            internal: IS_INTERNAL,
            filter_text: filterText
        });

        if (!data) {
            return;
        }

        let options = $.map(data, value => {
            let selectedFlag = parseInt(area) === value.id ? 'selected' : '';
            return `<option ${selectedFlag} value="${value.id}">${value.name} (${value.cantidad})</option>`;
        });

        $(SELECT_AREA).empty();
        $(SELECT_AREA).append(`<option value="" ${area === '' ? 'selected' : ''}>Area</option>`);
        $(SELECT_AREA).append(options);
    } catch (err) {
        console.error(new Error(err));
    }
}

function http_request(url, data) {
    return $.ajax({
        url: url,
        type: 'POST',
        data: data,
        dataType: 'json'
    });
}
